/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Teal_Bear_DashInputs */

const en_cool_teal_bear_dash = /** @type {(inputs: Cool_Teal_Bear_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk Configure`)
};

const de_cool_teal_bear_dash = /** @type {(inputs: Cool_Teal_Bear_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masseneinstellung`)
};

/**
* | output |
* | --- |
* | "Bulk Configure" |
*
* @param {Cool_Teal_Bear_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_teal_bear_dash = /** @type {((inputs?: Cool_Teal_Bear_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Teal_Bear_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_teal_bear_dash(inputs)
	return de_cool_teal_bear_dash(inputs)
});